import { GA_EVENTS } from "../../../utils/ga";
import { SignatoryRights } from "./components/SignatoryRights/SignatoryRights";
import { Shareholding } from "./components/Shareholding/Shareholding";
import { Nationality } from "./components/Nationality/Nationality";
import { StakeholderInfo } from "./components/Stakeholder/Stakeholder";
import { CountryOfResidence } from "./components/CountryOfResidence/CountryOfResidence";

export const FULL_NAME_MAX_LENGTH = 77;
export const STEP_1 = 1;
export const STEP_2 = 2;
export const STEP_3 = 3;
export const STEP_4 = 4;
export const STEP_5 = 5;

export const stakeholdersSalesAssistSteps = {
  true: [
    {
      step: STEP_1,
      title: "Stakeholder Info",
      component: StakeholderInfo,
      eventName: GA_EVENTS.SA_COMPANY_STAKEHOLDER_INFO_CONTINUE
    }
  ],
  false: [
    {
      step: STEP_1,
      title: "Stakeholder Info",
      component: StakeholderInfo,
      eventName: GA_EVENTS.SA_COMPANY_STAKEHOLDER_INFO_CONTINUE
    },
    {
      step: STEP_2,
      title: "Signatory Rights",
      component: SignatoryRights,
      eventName: GA_EVENTS.SA_COMPANY_STAKEHOLDER_SIGNATORY_RIGHTS_CONTINUE
    },
    {
      step: STEP_3,
      title: "Shareholding",
      component: Shareholding,
      eventName: GA_EVENTS.SA_COMPANY_STAKEHOLDER_SHAREHOLDING_CONTINUE
    },
    {
      step: STEP_4,
      title: "Nationality",
      component: Nationality,
      eventName: GA_EVENTS.SA_COMPANY_STAKEHOLDER_NATIONALITY_CONTINUE
    },
    {
      step: STEP_5,
      title: "Country of Residence",
      component: CountryOfResidence,
      eventName: GA_EVENTS.SA_COMPANY_STAKEHOLDER_COUNTRY_OF_RESIDENCE_CONTINUE
    }
  ]
};

export const COMPANY_STAKEHOLDER_Sales_Assist_ID = "companyStakeholderSalesAssist_";

export const SIGNATORY_INVOLVEMENT_PROOF = "signatoryInvolvementProof";
export const SISTER_COMPANY_TL_PROOF = "sisterCompanyTL";
